import { useField } from "formik"

import { selectEffectiveCompanyId } from "../../../../modules/context/contextSelectors"
import { UserType } from "../../../../modules/login/loginTypes"
import { useAppSelector } from "../../../../modules/store/storeHooks"

import { MeetingServicePriceListState } from "../createOrderTypes"
import { useCreateOrderFormConfig } from "../mainForm/CreateOrderFormContext"

// Products flagged "Staff only" (isAdminOnly) belong to one merchant's own staff, so the admin must
// both be a merchant admin and be looking at that merchant's price list — at CREATE the price list
// picker offers every merchant the customer has access to, not just the admin's own.
//
// user.userType is the type of the admin placing the order; ordering on behalf of someone never
// overwrites it. The merchant id must come from the selector, not user.companyId — picking an
// on-behalf user does overwrite that one with the chosen user's company.
export function useCanManageAdminOnlyProducts(): boolean {
    const { user } = useCreateOrderFormConfig()
    const merchantId = useAppSelector(selectEffectiveCompanyId)
    const [{ value: priceListState }] = useField<MeetingServicePriceListState>("priceList")

    if (user.userType !== UserType.MERCHANT) return false

    return !!merchantId && merchantId === priceListState.item?.merchantId
}
